import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { MainContainerService } from '../main-container/main-container.service';
import { JsonReturn, ObjectParam } from '../interface/generic-interface';

@Injectable()
export class PopupOcorrenciaService {

  loadingMsg = false;
  usuarioLogado: string = '';
  roteiroAlertaId = null;
  updateRoteiroAlerta = false;
  ocRoteiroBusca = null;

  public statusFinalizacaoSelecionado: any;
  constructor(
    private conService: ApiConService,
    private mainContainerService: MainContainerService
  ) { }

  async putVisualizacaoOcorrencia() {
    try {
      let id = this.mainContainerService.ocorrenciaSelecionado[0].CodigoOcorrencia;
      const IdOcorrencia = this.mainContainerService.ocorrenciaSelecionado[0].IdOcorrencia
      let vetOcorrenciaMsg = { 'VisualizadoDistribuidora': 'S' };
      let objParam: ObjectParam = { 
      ocorrencias: {
        IdStatus: 2, IdOcorrencia, Usuario: this.usuarioLogado 
        }      
      };
      const responseOcorrencia = await this.conService.put('DCocorrencias', String(id), objParam);
    }catch (Error) {
      console.log("CATCH________putVisualizacaoOcorrencia");
      console.log(Error);
    }
  }

  async consultaArquivo(codOcorrencia: string, idMensagem: number, formatoArquivo: string){
    const response: JsonReturn = await this.conService.patch(`DCocorrenciaMensagem/arquivo/${codOcorrencia}/${idMensagem}/${formatoArquivo}`);
    return response;
  }
}

